import { Component, ReactNode } from 'react';

interface Props {
  children: ReactNode;
}

interface State {
  hasError: boolean;
}

/**
 * Last-resort boundary around the entire app. If bootstrap throws
 * (e.g. storage blocked in a restricted webview), we render a minimal
 * dependency-free fallback instead of a blank page.
 */
export class RootErrorBoundary extends Component<Props, State> {
  state: State = { hasError: false };

  static getDerivedStateFromError(): State {
    return { hasError: true };
  }

  componentDidCatch(error: unknown) {
    // eslint-disable-next-line no-console
    console.error('[RootErrorBoundary]', error);
  }

  render() {
    if (!this.state.hasError) return this.props.children;

    const href = 'https://maestrocrm.it';
    const intent =
      'intent://maestrocrm.it#Intent;scheme=https;package=com.android.chrome;end';

    return (
      <div
        style={{
          minHeight: '100dvh',
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          justifyContent: 'center',
          padding: '24px',
          fontFamily:
            '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif',
          background: '#ffffff',
          color: '#0f172a',
          textAlign: 'center',
        }}
      >
        <img
          src="/icon-192.png"
          alt="Maestro CRM"
          width={72}
          height={72}
          style={{ borderRadius: 16, marginBottom: 20 }}
        />
        <h1 style={{ fontSize: 22, fontWeight: 600, margin: '0 0 8px' }}>
          Maestro CRM
        </h1>
        <p style={{ maxWidth: 320, margin: '0 0 20px', color: '#475569', lineHeight: 1.5 }}>
          Il browser interno che stai usando non supporta tutte le funzioni del sito.
          Apri il link nel tuo browser predefinito per continuare.
        </p>
        <a
          href={intent}
          style={{
            display: 'inline-block',
            padding: '12px 20px',
            borderRadius: 10,
            background: '#217BB8',
            color: '#ffffff',
            fontWeight: 600,
            textDecoration: 'none',
            marginBottom: 12,
          }}
        >
          Apri in Chrome
        </a>
        <a
          href={href}
          style={{ color: '#217BB8', fontSize: 14, textDecoration: 'underline' }}
        >
          Vai al sito
        </a>
      </div>
    );
  }
}
